import React from "react";

interface EducationProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  stroke?: string;
  width?: number | string;
  height?: number | string;
}

const Education: React.FC<EducationProps> = ({
  fill = "#3C3C3C",
  stroke = "none",
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.0732 18.5L4.07324 14.7V8.7L0.0732422 6.5L11.0732 0.5L22.0732 6.5V14.5H20.0732V7.6L18.0732 8.7V14.7L11.0732 18.5ZM11.0732 10.2L17.9232 6.5L11.0732 2.8L4.22324 6.5L11.0732 10.2ZM11.0732 16.225L16.0732 13.525V9.75L11.0732 12.5L6.07324 9.75V13.525L11.0732 16.225Z"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  );
};

export default Education;
